'use strict';
import e from "../external/js-cookie/dist/js.cookie.js";
const t = () => {
  const o = process.env.NEXT_PUBLIC_COOKIE_PREFIX + "mosh_ut_v2";
  return e.get(o) || "";
}, n = () => {
  const o = process.env.NEXT_PUBLIC_COOKIE_PREFIX + "mosh_uuid";
  return e.get(o) || "";
}, u = () => e.get("ajs_anonymous_id") || null;
export {
  u as getAnonymousUserId,
  t as getUserToken,
  n as getUserUuid
};
